const accordion = {};

accordion.generic = () => {

    let itemOpen = "accordion__item-open";
    let $accordionTitles = document.querySelectorAll(".js-accordion-title");

    for (let i=0;i<$accordionTitles.length;i++) {
        $accordionTitles[i].addEventListener("click",toggleItem,false);
    }

    function toggleItem(e){
        let $itemOpen = document.querySelector("."+itemOpen);
        let sameElem = false;
        if ($itemOpen){
            closeItem($itemOpen);
            sameElem = $itemOpen.querySelector(".js-accordion-title") === e.target;
        }
        if (!sameElem){
            let panel = e.target.parentNode;
            openItem(panel);
        }
    }

    function closeItem($itemOpen){
        let panelCopy = $itemOpen.querySelector(".accordion__copy");
        $itemOpen.classList.remove(itemOpen);
        panelCopy.style.display = 'none';
        panelCopy.style.opacity = '0';
    }

    function openItem(panel){
        let panelCopy = panel.querySelector(".accordion__copy");
        panel.classList.add(itemOpen);
        panelCopy.style.display = 'block';
        panelCopy.style.opacity = '1';

        let uploadCta = panel.querySelector(".label_custom");

        let submitCta = panel.querySelector(".wpcf7-submit");
        let title = panel.querySelector(".accordion__title--label").innerHTML;

        if ( jQuery(".contact-page").length > 0) {

            submitCta.addEventListener("click", () => trackingEventPiwik(_paq, ["trackEvent", "Contattaci - " + title, 'Click', "Invio Messaggio"]));


            if (jQuery(uploadCta).length > 0) {
                uploadCta.addEventListener("click", () =>

                trackingEventPiwik(_paq, ["trackEvent", "Contattaci  - Diventa uno di noi", "Click", "Upload CV"])

            );
            }
        }

        if (jQuery(".inspiring-days-page").length > 0) {


            submitCta.addEventListener("click", () =>  trackingEventPiwik(_paq, ["trackEvent", "Inspiring Days  - " + title, "Click", "Invio Messaggio"]));

        }


        if (window.matchMedia('(minx-width: 769px)').matches) {
            jQuery('html, body').animate({ scrollTop: jQuery(panel).offset().top - 115}, "2s");
        }
        else{
            jQuery('html, body').animate({ scrollTop: jQuery(panel).offset().top - 75}, "2s");
        }

    }

}

accordion.init = () => {
    accordion.generic();
}

jQuery(document).ready(function () {
    accordion.init();
});






document.addEventListener( 'wpcf7mailsent', function(  ) {


    let ga = window[window['GoogleAnalyticsObject'] || 'ga'];

    let panel = document.querySelector(".accordion__item-open");
    let title = panel.querySelector(".accordion__title--label").innerHTML;
    let quote = panel.querySelector(".thanks_message")
    let form = panel.querySelector("form");
    form.style.display = 'none';
    quote.style.display = 'block';







    if (jQuery(".contact-page").length > 0) {

        // GA event

        trackingEventPiwik(_paq, ["trackEvent", "Contattaci - " + title, "Send", "Thank you message"])






        let homeCta = quote.querySelector("#back-to-home-cta");

        if (jQuery(homeCta).length > 0) {

                homeCta.addEventListener("click", () =>

                 trackingEventPiwik(_paq, ["trackEvent", "Contattaci - " + title, "Click", "Torna alla home"])

                );

        }
    }

    if ((jQuery(".inspiring-days-page").length > 0)) {

        trackingEventPiwik(_paq, ["trackEvent", "Inspiring Days - " + title, "Send", "Thank you message"])

        let homeCta = quote.querySelector("#back-to-home-cta");

        if (jQuery(homeCta).length > 0) {
            homeCta.addEventListener("click", () =>

            trackingEventPiwik(_paq, ["trackEvent", "Inspiring Days - " + title, "Click", "Torna alla home"])

        );
        }
    }

}, false );

